/**
 * angular imports
 */

import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * rxjs imports
 */
import { Subscription } from 'rxjs';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';
/**
 * service imports
 */
import { GetService } from 'src/app/dataservices/get.service';
@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit{


  /**
   * string for label
   */
  @Input() label;
  /**
   * formcontrol name
   */
  @Input() formControlName;
  @Input() suggestionList = [];
  @Input() defaultValue;
  @Input() toShowDropDown = true;
  @Input() minLength: number;
  @Input() keyValue: string;

  @Input() callApiUrlForList  = true;
  @Input() apiUrl: string;

  @Input() isInerrorState = false;

  @Input() placeholder: string;

  @Input() mandatory=false;

  /**
   * Used to emit the selected value.
   */
  @Output() emitSelectedValue: EventEmitter<string> = new EventEmitter();
  /**
   * 
   * emiting event for focus
   */
  @Output() elementTouched: EventEmitter<null> =  new EventEmitter(); 
  doesSearchKeyExists: boolean;
  currentKeyWord: string;
    constructor(private getService: GetService, private chg: ChangeDetectorRef,
      public mls: NewLanguageService ) {

  }
  public defaultList = [];
  public defaultSelected: {value: string};

  public customKey = 'custom';
  /**
   * for api subscription
   */
  private subscriptions: Subscription = new Subscription();
  
  getSearchList(query = ''): void {
        this.subscriptions.add( this.getService.getSearchDataForDropDown(this.apiUrl + query).subscribe(data => { 
          if (data) {
            this.suggestionList = data.lc;
            if (data.status === 204) {
              this.suggestionList = [];
            }
            this.doesSearchKeyExists = false;
            if (data.lc) {
              if (query === '') {
                this.defaultList = this.suggestionList;
              }
              data.lc.map(element => {
                if (this.currentKeyWord && element.value.toLowerCase() == this.currentKeyWord.toLowerCase() && element.value.length === this.currentKeyWord.length) {
                  this.doesSearchKeyExists = true;
                }
              });
            }
            if (this.doesSearchKeyExists === false && this.currentKeyWord) {
              this.suggestionList.push({key: this.customKey, value: this.currentKeyWord });
            }
            this.chg.detectChanges();
            this.chg.markForCheck();
          }
     }));
 }
  ngOnInit(): void {
      this.defaultSelected = {'value': this.defaultValue};
      this.getSearchList();
  }

  onCompleteMethod(event): void {
    const  filtered = [];
    const query = event.query;
    this.currentKeyWord = event.query;
    if (this.callApiUrlForList && this.apiUrl) {
        this.getSearchList(event.query);
    }
    this.chg.detectChanges();
    this.chg.markForCheck();
 }

 onKeyUp(event): void {
  this.currentKeyWord = event.target.value;
  if (event.target.value.length > 2) {
      this.getSearchList(event.target.value);
  }
  else if (event.target.value.length > 0 && event.target.value.length <= 2) {
    this.suggestionList = [];
  }
  else if (event.target.value.length === 0) {
    if (this.defaultList) {
      this.suggestionList = this.defaultList;
      this.chg.detectChanges();
      this.chg.markForCheck();
    }
    else {
      this.getSearchList('');
    }
  }
  this.chg.detectChanges();
  this.chg.markForCheck();
  } 
selectedValues(event): void {
  this.emitSelectedValue.emit(event.value);
}
elementFocused(): void {
  this.elementTouched.emit();
} 
}
